<ng-container *ngIf="issuer">
  <p class="mb-2">
    <strong>{{ issuer.name }}</strong>
  </p>
  <p class="mb-2" *ngIf="!!issuer?.address">
    {{ issuer.address }}
  </p>
  <p class="mb-2" *ngIf="!!issuer?.address2">
    {{ issuer.address2 }}
  </p>
  <p
    class="mb-2"
    *ngIf="
      !!issuer?.city ||
      !!issuer?.zip
    "
  >
    {{ issuer.zip }}
    {{ issuer.city }}
  </p>
  <p class="mb-2" *ngIf="!!issuer?.country">
    {{ issuer.country }}
  </p>
  <p class="mb-2" *ngIf="issuer?.taxNumber">
    <span
      *ngIf="
        issuer.taxSubject;
        else notTaxSubject
      "
      >{{ 'document-view-public.document-issuer.tax-id' | translate }}:</span
    >
    <ng-template #notTaxSubject>
      {{ 'document-view-public.document-issuer.tax-id' | translate }}:
    </ng-template>
    <span id="org-tax_num-val">
      {{ issuer.taxNumber }}
    </span>
  </p>

  <p
    class="mb-2"
    *ngIf="
      (unit?.IBAN) ||
      issuer?.IBAN
    "
  >
    {{ 'document-view-public.document-issuer.iban' | translate }}:
    <span *ngIf="unit?.IBAN">{{
      unit.IBAN
    }}</span>
    <span
      *ngIf="
        !unit?.IBAN &&
        issuer.IBAN
      "
      >{{ issuer.IBAN }}</span
    >
  </p>

  <div class="row" *ngIf="unit">
    <div class="col">
      <br />

      <p class="mb-2">
        <strong appPrimaryColor>{{ unit.name }}</strong>
      </p>
      <p class="mb-2">
        <span *ngIf="unit.address">{{
          unit.address
        }}</span
        ><span *ngIf="unit.address2"
          >, {{ unit.address2 }}</span
        ><span *ngIf="unit.zip"
          >, {{ unit.zip }}</span
        ><span *ngIf="unit.city"
          ><span *ngIf="!unit.zip">,</span>
          {{ unit.city }}</span
        ><span *ngIf="unit.country"
          >, {{ unit.country }}</span
        >
      </p>
    </div>
  </div>
</ng-container>